/** User-agent OS names as people say them ("Mac OS X" is macOS). */
const OS_DISPLAY: Record<string, string> = {
  'mac os x': 'macOS',
  'mac os': 'macOS',
  macos: 'macOS',
  'chrome os': 'ChromeOS',
}

export const osDisplayName = (name: string) => OS_DISPLAY[String(name).trim().toLowerCase()] ?? name
